import type { ReactNode } from "react";

export interface PluginDetail {
  label: ReactNode;
  desc: ReactNode;
}

// TODO: pull plugin data from the API
// This is a temporary manual approach to show plugin details on the HoverCard
const pluginDetails: Record<string, PluginDetail> = {
  artifacts: {
    label: "Artifacts Buildkite Plugin",
    desc: "🆙 Automatically upload and download artifacts",
  },
  "aws-assume-role-with-web-identity": {
    label: "AWS assume-role-with-web-identity",
    desc: "A Buildkite plugin to assume-role-with-web-identity using a Buildkite OIDC token before running the build command.",
  },
  cache: {
    label: "Cache Buildkite Plugin",
    desc: "🎩🗄Cache ephemeral files between builds.",
  },
  docker: {
    label: "Docker Buildkite Plugin",
    desc: "🐳📦 Run any build step in a Docker container",
  },
  "golang-cross-compile": {
    label: "Golang Cross Compile Buildkite Plugin",
    desc: "✨ Cross-Compile Go binaries across multiple operating system, architecture and Go versions in parallel.",
  },
  "junit-annotate": {
    label: "JUnit Annotate Buildkite Plugin",
    desc: "📈 Summarise your test failures as a build annotation",
  },
};

export default pluginDetails;
